@if (activeQuestion$()) {
  <div [formGroup]="activeQuestion$()" class="rating-settings__container">
    <div class="rating-settings__input-containers">
      <empathy-required-setting [activeQuestion]="activeQuestion$()"></empathy-required-setting>
      <empathy-min-view-time-setting [activeQuestion]="activeQuestion$()" [showBorder]="false"></empathy-min-view-time-setting>
    </div>

    <empathy-media-settings [activeQuestion]="surveyEditorService.surveyEditor$().activeQuestion"></empathy-media-settings>

    @if (activeQuestion$().get('cards')) {
      <empathy-cards-settings [activeQuestion]="activeQuestion$()"></empathy-cards-settings>
    }

    @if (activeQuestion$().get('ratingType').value === ratingType.descriptive) {
      <empathy-choice-settings [activeQuestion]="activeQuestion$()"></empathy-choice-settings>
    }
  </div>
}
